import React, {useContext} from "react";
import "./Services.css";
import ServicesCard from "../../components/servicesCard/ServicesCard";
import {servicesSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
export default function Services() {
  const {isDark} = useContext(StyleContext);
  if (!servicesSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="services">
        <div className="services-header">
          <h1 className="services-header-text">{servicesSection.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode services-subtitle"
                : "subTitle services-subtitle"
            }
          >
            {servicesSection.subtitle}
          </p>
        </div>
        <div className="services-main-div">
          <div className="services-text-div">
            {servicesSection.services.map((services, i) => {
              return (
                <ServicesCard
                  key={i}
                  isDark={isDark}
                  services={{
                    url: services.url,
                    image: services.image,
                    title: services.title,
                    description: services.description,
                    isLatest: services.isLatest
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
